import React from 'react';
import { AIframeProps, AIframeAspectRatio } from './AIframe.types';
import * as Styled from './AIframe.styles';

const COMPONENT_NAME = 'a-web-ui-kit-AIframe';
const TEST_ID = 'web-ui-kit-AIframe';

export const AIframe: React.FC<AIframeProps> = ({
  url,
  aspectRatio = AIframeAspectRatio.Ratio1x1,
  className,
  ...rest
}) => {
  if (!url) {
    return null;
  }

  return (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      data-aspect-ratio={aspectRatio}
      $aspectRatio={aspectRatio}
      className={className}
    >
      <Styled.IframeElement src={url} {...rest} />
    </Styled.Wrapper>
  );
};

export { AIframeAspectRatio, TEST_ID as A_IFRAME_TEST_ID };
export type { AIframeProps } from './AIframe.types';
